// extracted by mini-css-extract-plugin
export default {"description":"PJ76w_J6","steps":"wEWsuBL3"};